import { createContext } from 'react'
import { activityCenterObject } from '../fileToolbar/ActivityCenter/activityCenterTypes'
/*
 * This context is for passing down the function to navigate the main component of our shell
 */
export type ActivityCenterContextType = {
    Add: (
        msg: string,
        onclick: activityCenterObject['browserLink'],
        type: activityCenterObject['type'],
        lddActivityCenterTracker: string,   // dev's responsbility of naming the tracker, tracker has to be unique in the whole ReactShell wise
        clearWhenOut?: boolean
    ) => void,
    Delete: (index: string) => void,
    ClearWhenOut: () => void
}
export const ActivityCenterContext = createContext<ActivityCenterContextType>(null);